// PageDescription: 의약품 사전 검색 페이지
import MedicineDictionarySearchTemplate from '@/components/templates/medicine-dictionary/MedicineDictionarySearchTemplate';
import useMedicineDictionarySearchViewModel from '@/hooks/medicine-dictionary/useMedicineDictionarySearchViewModel';
import { CustomPageProps } from '@/types/app';

const MedicineDictionarySearchPage = ({ client }: CustomPageProps) => {
  const viewModel = useMedicineDictionarySearchViewModel();

  return <MedicineDictionarySearchTemplate viewModel={viewModel} client={client} />;
};

export default MedicineDictionarySearchPage;
